"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uiSchema = {
    type: "VerticalLayout",
    elements: [
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/frequencyRemaining",
                },
                {
                    type: "Control",
                    scope: "#/properties/startingFromWeekOf",
                    options: {
                        format: "date",
                        disablePast: true,
                    },
                },
            ],
        },
        { type: "Control", scope: "#/properties/notes" },
    ],
};
exports.default = uiSchema;
